<template>
  <v-container id="zcierreform" tag="section">
    <base-v-component heading="Listado Z Cierres " />
    <base-material-card
      color="indigo"
      icon="mdi-credit-card-multiple"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn
          color="secondary"
          @click="$router.push('/admin/negocio/zcierres')"
        >
          <v-icon color="white">mdi-arrow-left</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card id="capture" flat rounded="0" color="blue-grey lighten-5">
        <v-toolbar dark style="z-index: 1" min-height="100%">
          <v-row justify="center" align="center">
            <v-col cols="12" sm="4">
              <h2
                :class="$vuetify.breakpoint.smAndDown ? 'caption' : 'body-1'"
                class="font-weight-black"
              >
                CIERRE DIARIO FINALIZAR
              </h2>
              <v-spacer></v-spacer>
            </v-col>
            <v-col cols="12" md="4" v-if="false">
              <v-select
                v-model="graficasMostrar"
                label="Visualización"
                :items="graficasMostrarItems"
                style="max-width: 200px"
                dense
                solo
                light
                hide-details
                class="elevation-0 mr-8"
                background-color="white"
                color="secondary"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="tipoMostrar"
                label="Tipo mostrar"
                :items="tipoMostrarItems"
                style="max-width: 200px"
                dense
                solo
                light
                hide-details
                class="elevation-0 mr-8"
                background-color="white"
                color="secondary"
              />
            </v-col>
          </v-row>
        </v-toolbar>
        <v-card-text
          class="pt-4 blue-grey lighten-5 border"
          v-if="resumenCierre"
        >
          <v-row style="height: calc(100vh - 154px)">
            <!-- izquierda -->
            <v-col cols="12" class="flex-grow-1 scroll-y--helper">
              <v-row>
                <v-col cols="12">
                  <v-card rounded="lg" elevation="1">
                    <v-card-text>
                      <v-row id="cabecera">
                        <v-col cols="12" md="3">
                          <div class="title text-center">Total ventas</div>
                          <div class="title font-weight-bold text-center">
                            {{
                              mostrarMoneda(
                                resumenCierre[tipoMostrar].totales.total
                              )
                            }}
                            €
                          </div>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="12" md="3">
                          <div class="title text-center">Total pedidos</div>
                          <div class="title font-weight-bold text-center">
                            {{ resumenCierre[tipoMostrar].totales.numPedidos }}
                          </div>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="12" md="3">
                          <div class="title text-center">Hora inicio</div>
                          <div class="title font-weight-bold text-center">
                            {{ cierreComputed.inicioMostrar }}
                          </div>
                        </v-col>
                        <v-divider vertical></v-divider>
                        <v-col cols="12" md="3">
                          <div class="title text-center">Hora cierre</div>
                          <div class="title font-weight-bold text-center">
                            {{ cierreComputed.finMostrar }}
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" v-if="cuentasCierre">
                  <v-card id="formasPagoTabla" rounded="lg">
                    <v-card-text>
                      <v-simple-table class="mr-1 mb-1 overflow-hidden">
                        <thead>
                          <tr>
                            <th>CIERRE DE CUENTAS</th>

                            <th class="text-right">Inicio efectivo</th>
                            <th class="text-right">Fin efectivo debía</th>
                            <th class="text-right">Fin efectivo hay</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(r, i) in cuentasCierre" :key="i">
                            <td class="font-weight-bold">{{ r.nombre }}</td>

                            <td class="font-weight-bold text-right">
                              {{ mostrarMoneda(r.efectivo) }}
                            </td>

                            <td
                              class="
                                text-right
                                font-weight-bold
                                success--text
                                text-h5
                              "
                            >
                              {{ mostrarMoneda(r.efectivoFinDebe) }}€
                            </td>
                            <td
                              class="
                                text-right
                                font-weight-bold
                                success--text
                                text-h5
                              "
                            >
                              {{ mostrarMoneda(r.efectivoFinHay) }}€
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12">
                  <v-card id="formasPagoTabla" rounded="lg">
                    <v-card-text>
                      <v-simple-table class="mr-1 mb-1 overflow-hidden">
                        <thead>
                          <tr>
                            <th>FORMA DE PAGO</th>

                            <th class="text-right">Total vendido</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(r, i) in resumenCierreFormasPago"
                            :key="i"
                          >
                            <td class="font-weight-bold">{{ r.nombre }}</td>

                            <td
                              class="
                                text-right
                                font-weight-bold
                                success--text
                                text-h5
                              "
                            >
                              {{ r.totalMostrar }}€
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="12" class="pb-1">
                  <v-card id="modosTabla" rounded="lg">
                    <v-card-text>
                      <v-simple-table class="mr-1 mb-1 overflow-hidden">
                        <thead>
                          <tr>
                            <th>MODO</th>
                            <th class="text-center">Número de pedidos</th>
                            <th class="text-right">Total vendido</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(r, i) in resumenCierreModo" :key="i">
                            <td class="font-weight-bold">{{ r.nombre }}</td>
                            <td class="text-center text-h5">
                              {{ r.numPedidos }}
                            </td>
                            <td
                              class="
                                text-right
                                font-weight-bold
                                success--text
                                text-h5
                              "
                            >
                              {{ r.totalMostrar }}€
                            </td>
                          </tr>
                        </tbody>
                      </v-simple-table>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </base-material-card>
  </v-container>
</template>

<script>
import { mostrarMoneda } from "@/utils/utils.js";
import moment from "moment-timezone";
export default {
  data: () => {
    return {
      tipoMostrar: "cobrados",
      graficasMostrar: "tablas",
      cierre: {},
    };
  },
  computed: {
    cuentasCierre() {
      return this.cierreComputed ? this.cierreComputed.datos.cuentas : false;
    },
    resumenCierreModo() {
      if (!this.resumenCierre.cobrados) return [];
      return [
        //this.resumenCierre[this.tipoMostrar].totales,
        ...Object.values(this.resumenCierre[this.tipoMostrar].modos),
        ...Object.values(this.resumenCierre[this.tipoMostrar].cuentas),
      ].map((p) => {
        return {
          ...p,
          totalMostrar: mostrarMoneda(p.total, true),
          efectivoMostrar: mostrarMoneda(p.efectivo, true),
          tarjeta_domicilioMostrar: mostrarMoneda(p.tarjeta_domicilio, true),
          tarjeta_onlineMostrar: mostrarMoneda(p.tarjeta_online, true),
          tarjeta_localMostrar: mostrarMoneda(p.tarjeta_local, true),
          localMostrar: mostrarMoneda(p.local, true),
          otroMostrar: mostrarMoneda(p.otro, true),
        };
      });
    },
    resumenCierreFormasPago() {
      if (!this.resumenCierre.cobrados) return [];
      return [
        //this.resumenCierre[this.tipoMostrar].totales,
        {
          nombre: "EFECTIVO",
          total: this.resumenCierre[this.tipoMostrar].totales.efectivo,
          totalMostrar: mostrarMoneda(
            this.resumenCierre[this.tipoMostrar].totales.efectivo,
            true
          ),
        },
        {
          nombre: "TARJETA ONLINE",
          total: this.resumenCierre[this.tipoMostrar].totales.tarjeta_online,
          totalMostrar: mostrarMoneda(
            this.resumenCierre[this.tipoMostrar].totales.tarjeta_online,
            true
          ),
        },
        {
          nombre: "TARJETA DOMICILIO",
          total: this.resumenCierre[this.tipoMostrar].totales.tarjeta_domicilio,
          totalMostrar: mostrarMoneda(
            this.resumenCierre[this.tipoMostrar].totales.tarjeta_domicilio,
            true
          ),
        },
        {
          nombre: "TARJETA LOCAL",
          total: this.resumenCierre[this.tipoMostrar].totales.tarjeta_local,
          totalMostrar: mostrarMoneda(
            this.resumenCierre[this.tipoMostrar].totales.tarjeta_local,
            true
          ),
        },
        {
          nombre: "OTRO",
          total: this.resumenCierre[this.tipoMostrar].totales.otro,
          totalMostrar: mostrarMoneda(
            this.resumenCierre[this.tipoMostrar].totales.otro,
            true
          ),
        },
      ];
    },
    resumenCierre() {
      console.log(this.cierreComputed);
      return this.cierreComputed && this.cierreComputed.datos
        ? this.cierreComputed.datos.resumen
        : false;
    },
    graficasMostrarItems() {
      return [
        //{ text: "Mostrar gráficas", value: "graficas" },
        { text: "Mostrar tablas", value: "tablas" },
      ];
    },
    tipoMostrarItems() {
      return [
        { text: "Cobrados", value: "cobrados" },
        { text: "Pendientes", value: "pendientes" },
      ];
    },
    cierreComputed() {
      return {
        ...this.cierre,
        inicioMostrar: moment.unix(this.cierre.inicio).format("HH:mm"),
        finMostrar: moment.unix(this.cierre.fin).format("HH:mm"),
      };
    },
  },
  methods: {
    mostrarMoneda(s) {
      return mostrarMoneda(s);
    },
  },
  async mounted() {
    console.log(this.$route.params.idcierre);
    this.cierre = await this.$store.dispatch(
      "zcierres/getZCierreConcreto",
      this.$route.params.idcierre
    );
    console.log(this.cierre);
  },
};
</script>

<style>
</style>